import { env } from '~/helpers/env'

/**
 * Télécharge un fichier produit par l'API (rapport PDF…) sous le nom qu'elle
 * annonce : c'est le serveur qui connaît la langue de l'organisation et la
 * date de génération, et deux sources produiraient deux noms différents.
 */
export async function downloadFromApi(path: string, fallbackName: string, body?: unknown): Promise<void> {
  // Un corps part en POST : ce qu'il porte (mots de passe d'une fiche, #271) n'a rien à faire dans une URL.
  const res = await fetch(`${env.api.url}${path}`, {
    credentials: 'include',
    ...(body !== undefined && {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }),
  })
  if (!res.ok) throw new Error((await errorCode(res)) ?? `download failed (${res.status})`)
  const blob = await res.blob()
  const fileName = res.headers.get('Content-Disposition')?.match(/filename="(.+)"/)?.[1] ?? fallbackName
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.click()
  URL.revokeObjectURL(url)
}

/**
 * Le code d'erreur que l'API renvoie (`REPORT_TOO_LARGE`…), pour que l'écran
 * dise quoi faire plutôt qu'un échec générique ; null si la réponse n'en porte pas.
 */
async function errorCode(res: Response): Promise<string | null> {
  try {
    const body: unknown = await res.json()
    const message = typeof body === 'object' && body !== null ? (body as { message?: unknown }).message : null
    return typeof message === 'string' ? message : null
  } catch {
    return null
  }
}
